export default "__VITE_ASSET__DXTVx5mQ__"